import { render } from "./MixIssue.vue?vue&type=template&id=51952edc"
import script from "./MixIssue.vue?vue&type=script&lang=js"
export * from "./MixIssue.vue?vue&type=script&lang=js"

import exportComponent from "/Users/hitenradadiya/Front/shiv_mfg_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__